import { useParams } from "react-router";

import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { SmartTable } from "src/components/SmartTable";
import { formatMoneyString } from "src/utility/utilityFunctions";

import { displayOrderSetStatus, getExtendedCost } from "../helpers";
import { useOptionalOrderSetId } from "../orderSet/data/useOrderSetId";
import { orderSetsKeyFactory } from "../queries";
import useOrderWindowPrograms from "./usePreOrderPrograms";

const PreOrderProgramsSummary = () => {
  const { orderWindowId } = useParams();
  const orderSetId = useOptionalOrderSetId();
  const { data: orders = [] } = useQuery({
    ...orderSetsKeyFactory.detail(orderSetId)._ctx.orders,
    enabled: !!orderSetId,
    staleTime: Infinity,
  });

  const liveOrderSetExtendedTotal = _.sumBy(orders, getExtendedCost);
  const liveTotalItems = _.sumBy(orders, (o) => o.totalQuantity);

  const { data } = useOrderWindowPrograms(orderWindowId);

  const rows = _(data)
    .flatMap((d) => (d.orderSet ? [d.orderSet] : []))
    .map((os) => ({
      ...os,
      extendedEstimatedCost:
        os.id === orderSetId
          ? liveOrderSetExtendedTotal
          : +os.totalExtendedCost,
      totalQuantity: os.id === orderSetId ? liveTotalItems : +os.totalQuantity,
    }))
    .sortBy("program.primaryBrand.id")
    .value();

  const totalQuarterlySpend = rows.reduce(
    (total, orderSet) => total + orderSet.extendedEstimatedCost,
    0
  );

  return (
    <>
      <div className="rounded bg-white overflow-hidden shadow-sm">
        <SmartTable
          noResultsText="No orders to show"
          error={null}
          rows={rows}
          columns={[
            {
              id: "_programName",
              label: "Pre-Order Program",
              render: (_, row) =>
                `${
                  row.program?.brands.length === 1
                    ? row.program?.brands[0].name
                    : "Multi Brand"
                } - ${row.program!.name}`,
            },
            {
              id: "status",
              label: "Status",
              render: displayOrderSetStatus,
            },
            {
              id: "totalQuantity",
              label: "Total Items",
            },
            {
              id: "extendedEstimatedCost",
              label: "Total Est Cost",
              align: "right",
              render: formatMoneyString,
            },
          ]}
        />
      </div>
      <div className="flex justify-end mt-4 mr-4 text-lg">
        Total Quarterly Spend: {formatMoneyString(totalQuarterlySpend)}
      </div>
    </>
  );
};

export default PreOrderProgramsSummary;
